import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface IAuthStoreState {
  resendVerifyToken?: string;
  email?: string;
}

interface IAuthStoreAction {
  setResendVerifyToken: (value: string) => void;
  setEmail: (value: string) => void;
}

type TAuthStore = IAuthStoreState & IAuthStoreAction;

const initialState: IAuthStoreState = {};

export const useAuthStore = create<TAuthStore>()(
  persist(
    (set) => ({
      ...initialState,

      setEmail: (email) => {
        set({ email });
      },

      setResendVerifyToken: (token) => {
        set({ resendVerifyToken: token });
      },
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
